<script lang="ts">
  import Skeleton from "./Skeleton.svelte";

  export let rows: number = 1;
</script>

<div class="container">
  {#each Array(rows) as _row}
    <div class="row">
      {#each Array(rows) as _column}
        <div>
          <Skeleton --skeleton-height="12px" --skeleton-width="100%" --skeleton-radius="2px" />
        </div>
      {/each}
    </div>
  {/each}
</div>

<style>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  }
  .row {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    border-bottom: solid 1px var(--rk-divider-0);
    padding: 18px 0;
  }
</style>
